import { format } from "date-fns";

export const sendProtoTasks = (): Function => (state, actions): void => {
  const {
    api,
    clientID,
    scheduling: { date, time = "00:00", user },
    [state.scheduling.from]: { selected },
  } = state;

  const datetime = `${date}T${time}${format(new Date(), "ZZ")}`;

  const protoTasks = selected.map(({ id }) => {
    return {
      datetime,
      placeID: id,
      userID: user.id,
    };
  });

  const headers = new Headers({
    authorization: state.authorization,
    "Content-Type": "application/json",
  });

  const fetching = fetch(`${api}/v1/tasks/${clientID}`, {
    body: JSON.stringify(protoTasks),
    headers,
    method: "post",
  });

  fetching
    .then(response => {
      if (!response.ok) {
        throw { reason: new Error(response.statusText) };
      }
      return response.json();
    })
    .then(() => actions.setSendingProtoTasksSucceded())
    .catch(reason => actions.setSendingProtoTasksFailed({ reason }));

  return {
    ...state,
    scheduling: {
      ...state.scheduling,
      sending: true,
    },
  };
};
